module.exports = __webpack_public_path__ + "assets/img/NationalPlan.e0bb9389.png";